import { render, staticRenderFns } from "./fileTemplate.vue?vue&type=template&id=5ab75940&scoped=true&"
import script from "./fileTemplate.vue?vue&type=script&lang=js&"
export * from "./fileTemplate.vue?vue&type=script&lang=js&"
import style0 from "./fileTemplate.vue?vue&type=style&index=0&id=5ab75940&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab75940",
  null
  
)

export default component.exports